import AnimatedText from "../../styles/KalonMethod_AnimatedText";
import KalonPillars_ending from "../../assets/Pillars/P3_sports2.jpg";

export default function PageConclusion() {
  return (
    <section className="relative w-full bg-gradient-to-b from-black/40 to-black/10 overflow-hidden py-20 md:py-28">
      
      {/* Background Accent Shapes */}
      <div className="absolute -top-24 -left-16 w-80 h-80 bg-cyan-500/20 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute -bottom-24 -right-16 w-80 h-80 bg-purple-500/20 rounded-full blur-3xl animate-pulse-slow"></div>

      <div className="relative max-w-7xl mx-auto flex flex-col md:flex-row-reverse items-center gap-12 px-6 md:px-12">
        
        {/* Image Column */}
        <div className="md:w-1/2 relative flex justify-center md:justify-end">
          <div className="relative w-full">
            
            {/* Floating Layered Borders */}
            <div className="absolute -top-4 -left-4 w-full h-full rounded-3xl border-2 border-cyan-500/20 transform rotate-2 shadow-lg"></div>
            <div className="absolute -bottom-4 -right-4 w-full h-full rounded-3xl border-2 border-purple-500/20 transform -rotate-2 shadow-lg"></div>

            {/* Main Image */}
            <div className="relative overflow-hidden rounded-3xl shadow-2xl">
              <img
                src={KalonPillars_ending}
                alt="Kalon Pillars Ending"
                className="w-full h-[28rem] md:h-[32rem] object-cover transform transition-transform duration-500 hover:scale-105"
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>

            {/* Floating Accent Circles */}
            <div className="absolute -top-10 -left-10 w-20 h-20 border-4 border-cyan-400 rounded-full opacity-40 animate-pulse-slow"></div>
            <div className="absolute -bottom-8 -right-12 w-28 h-28 border-4 border-purple-400 rounded-full opacity-30 animate-pulse-slow"></div>
          </div>
        </div>

        {/* Text Column */}
        <div className="md:w-1/2 text-center md:text-left space-y-6">
          
          <AnimatedText delay={100}>
            <h2 className="text-white text-4xl sm:text-7xl font-extrabold leading-tight drop-shadow-lg">
              Your Peak Performance Awaits
            </h2>
          </AnimatedText>

          <AnimatedText delay={300}>
            <p className="text-neonTurquoise text-lg sm:text-3xl font-semibold drop-shadow-md">
              Performance - Transformation - Mastery
            </p>
          </AnimatedText>

          <AnimatedText delay={500}>
            <p className="text-gray-300 text-base sm:text-2xl max-w-xl drop-shadow-sm">
              The Kalon 4-Pillar System isn't just training—it's a complete transformation. Build endurance that never quits. Sculpt strength that turns heads. Master the sports you love. Fuel a body built for longevity. This is performance without compromise. This is your potential, realized.
            </p>
          </AnimatedText>

        </div>

      </div>

      {/* Bottom Curved Divider */}
      <div className="absolute bottom-0 w-full h-20 md:h-28 bg-gradient-to-t from-black/20 to-transparent rounded-t-full"></div>
    </section>
  );
}
